import { render, staticRenderFns } from "./orgList.vue?vue&type=template&id=70dfb9dd&scoped=true"
import script from "./orgList.vue?vue&type=script&lang=js"
export * from "./orgList.vue?vue&type=script&lang=js"
import style0 from "./orgList.vue?vue&type=style&index=0&id=70dfb9dd&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70dfb9dd",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/gkzy/Desktop/achievement-transform-system/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('70dfb9dd')) {
      api.createRecord('70dfb9dd', component.options)
    } else {
      api.reload('70dfb9dd', component.options)
    }
    module.hot.accept("./orgList.vue?vue&type=template&id=70dfb9dd&scoped=true", function () {
      api.rerender('70dfb9dd', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/requirementAnalysis/comps/orgList.vue"
export default component.exports